
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useCollectionData = () => {
  // Collections data
  const { data: collections = [] } = useQuery({
    queryKey: ['networkViewCollections'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('collections')
        .select('id, name, color');
      
      if (error) {
        console.error('Error fetching collections:', error);
        return [];
      }
      
      return data;
    },
    staleTime: 60000,
  });

  const collectionColorMap = useMemo(() => {
    const map: Record<string, string> = {};
    collections.forEach((collection: any) => {
      map[collection.id] = collection.color || "#6B7789";
    });
    return map;
  }, [collections]);

  const { data: contentCollections = [] } = useQuery({
    queryKey: ['networkViewContentCollections'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('content_collections')
        .select('content_id, collection_id');
      
      if (error) {
        console.error('Error fetching content collections:', error);
        return [];
      }
      
      return data;
    },
    staleTime: 60000,
  });

  const contentToCollectionMap = useMemo(() => {
    const map: Record<string, string> = {};
    contentCollections.forEach((relation: any) => {
      map[relation.content_id] = relation.collection_id;
    });
    return map;
  }, [contentCollections]);

  return {
    collections,
    collectionColorMap,
    contentToCollectionMap
  };
};
